import Vue from "vue";
import Vuex from "vuex";
import router from "./router";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem("token"),
    userType: localStorage.getItem("userType"),
    userData: {},
    email: "",
    menus: [],
    initial: "",
    appLoading: false,
  },
  mutations: {
    loginUser(state, payload) {
      localStorage.setItem("token", payload);
      state.isLoggedIn = true;
      // Navigate to dashboard after login
      router.push("/dashboard").catch(() => {});
    },

    logoutUser(state) {
      // 1. Reset State
      state.userType = null;
      state.isLoggedIn = false;
      state.userData = {};
      state.initial = "";
      state.email = "";
      
      // 2. Clear Local Storage
      localStorage.removeItem("userType");
      localStorage.removeItem("token");

      // 3. Force Redirect to Login (root)
      // We use .catch to prevent "redundant navigation" errors in console
      router.push("/").catch(() => {});
    },

    userData(state, payload) {
      state.userData = payload;
      state.email = payload.phone;
    },

    userType(state, payload) {
      localStorage.setItem("userType", payload);
      state.userType = payload;
    },

    appLoading(state, payload) {
      state.appLoading = payload;
    }
  }
});